import script from "./RoleManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleManagement.vue?vue&type=script&setup=true&lang=js"

import "./RoleManagement.vue?vue&type=style&index=0&id=83dd4bf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83dd4bf0"]])

export default __exports__